export enum BackgroundEffectsType {
  none = 'none',
  blur = 'blur',
}
